module.exports = __webpack_public_path__ + "static/media/burger.86595150.svg";